module.exports = __webpack_public_path__ + "img/safe.8e0aeba7.png";